import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/cases/listpage/modernization/Template'

const Modernization: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'事例 実績 モダナイゼーション DX 生成AI E2Eテスト'}
        image={'https://www.i3design.jp/OGP_logo.png'}
        url={'https://www.i3design.jp/cases/modernization/'}
        title="モダナイゼーション | 事例 | i3DESIGN アイスリーデザイン"
        description="モダナイゼーションサービスのケーススタディを紹介します｜クラウドネイティブ、AI駆動開発、デザインシステムに精通した様々な支援実績がございます。UX/UIデザイン、モダンスタック技術、CI/CD、DevOps環境、AIエージェントをフル活用した開発スタイルで顧客のデジタルシフトを支援します。"
      />
      <Template pageId={1} />
    </>
  )
}

export default Modernization
